import { FIELD_TYPES } from '@witmetrics/utils/constants';
import { toDictionary } from '@witmetrics/utils/arrays';

export const FIELDS = toDictionary(Object.values(FIELD_TYPES), 'id');
